import { render, staticRenderFns } from "./PortalLogin.vue?vue&type=template&id=73a6890c&scoped=true&"
import script from "./PortalLogin.vue?vue&type=script&setup=true&lang=js&"
export * from "./PortalLogin.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PortalLogin.vue?vue&type=style&index=0&id=73a6890c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a6890c",
  null
  
)

export default component.exports